export default {
  radioContainer: {
    width: '100%',
    marginTop: 5
  }
};
